import { render, staticRenderFns } from "./PlafondsNews.vue?vue&type=template&id=6beb6bef&"
import script from "./PlafondsNews.vue?vue&type=script&lang=js&"
export * from "./PlafondsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports